<template>
  <div class="verify-btn" :class="{'disabled': disable || loading}" @click.stop="verifyBtnClick">
    <v-progress-circular v-if="loading" class="mr-1" indeterminate size="20" width="3"></v-progress-circular>
    {{btnText}}
  </div>
</template>

<script>
import { commonApi } from '@/api/commonApi';
import geetestMixin from '@/common/mixin/geetest2';

export default {
  name: 'VerifyBtn',
  mixins: [geetestMixin],
  props: {
    // 按钮文字
    text: {
      type: String,
      default: '发送验证码'
    },
    // 倒计时正在进行时的按钮文字
    onProgressText: {
      type: String,
      default: '{time}秒后重发'
    },
    // 倒计时结束后的按钮文字
    onStopedText: {
      type: String,
      default: '发送验证码'
    },
    // 是否需要极验
    geetest: {
      type: Boolean,
      default: false
    },
    // 倒计时时间，以秒为单位
    time: {
      type: Number,
      default: 60
    },
    // 按钮是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 按钮禁用的样式
    disableClass: {
      type: String,
      default: 'disabled'
    },
    // 短信/邮箱模板
    templateCode: {
      type: String,
      default: commonApi.SMS_TYPE.DYNAMIC_VERIFY_CODE
    },
    // 手机或邮箱号
    value: {
      default: ''
    },
    // 发送验证码的类型，值有email、phone
    type: {
      type: String,
      default: ''
    },
    // 国际区号，只有当type = phone时有效
    countryCode: {
      type: String,
      default: ''
    },
    // 执行条件，函数返回true才会发送验证码，否则不会发送
    condition: {
      type: Function,
      default() {
        return function() {
          return true;
        };
      }
    }
  },
  data() {
    return {
      // 是否是第一次执行
      isFirstStart: true,
      // 倒计时是否开始了
      started: false,
      // 倒计时是否结束了
      stoped: false,
      disable: this.disabled,
      // 倒计时时间
      countTime: parseInt(this.time),
      timer: null,
      loading: false
    };
  },
  methods: {
    async verifyBtnClick() {
      let that = this;
      let condition = await this.condition();
      let mailReg = /^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+(\.[a-zA-Z]{2,3})+$/;
      // mobileReg = /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      // 手机号只要不包含空格就ok，因为还有国外手机号
      let mobileReg = /\s/;
      if (
        !this.type ||
        (this.type !== 'phone' && this.type !== 'email' && this.type !== 'register' && this.type !== 'forgot-pwd')
      ) {
        console.error('没有传递type，或type的值不是email或phone');
        return;
      }
      if (this.type === 'phone' && !this.countryCode) {
        console.error('没有传递countryCode');
        return;
      }
      if (this.disable || this.started) {
        return;
      }

      if (condition === false) {
        return;
      }
      if (!that.value) {
        console.error(that.value + '不是合法的邮箱或手机号！');
        return;
      }
      if (!mailReg.test(that.value) && mobileReg.test(that.value)) {
        console.error(that.value + '不是合法的邮箱或手机号！');
        return;
      }

      if (this.geetest && this.showGeetest) {
        if (!this.captchaObj) {
          console.error('[VerifyBtn组件]极验初始化失败！');
        } else {
          this.captchaObj.verify();
        }
      } else {
        if (this.loading) {
          return;
        }
        this.loading = true;
        that
          ._sendMsg()
          .then(res => {
            if (!res || res.errcode !== 0) {
              this.loading = false;
              return;
            }
            this.loading = false;
            that.isFirstStart = false;
            that.started = true;
            that.stoped = false;
            that.disable = true;
            that.$emit('onstart', that.countTime);
            this.timer = setInterval(() => {
              if (that.countTime - 1 < 0) {
                clearInterval(that.timer);
                that.started = false;
                that.stoped = true;
                that.disable = false;
                that.countTime = parseInt(that.time);
                that.$emit('onstop', that.countTime);
                return;
              }
              that.countTime--;
              that.$emit('onprogress', that.countTime);
            }, 1000);
          })
          .catch(error => {
            console.error('error', error);
            this.loading = false;
          });
      }
    },
    // 强制中断计时
    abort() {
      clearInterval(this.timer);
      this.countTime = parseInt(this.time);
      this.started = false;
      this.stoped = true;
      this.disable = false;
    },
    // 真正的发送短信/邮箱
    /* _sendMsg () {
      let countryCode = this.countryCode;
      let isPhone = this.type === 'phone';
      if (isPhone) {
        if (countryCode.charAt(0) !== '+') {
          countryCode = '+' + countryCode;
        }
      }
      commonApi.sendSms(this.value, this.templateCode, isPhone ? 2 : 1, countryCode)
        .then(() => {
          this.$q.notify({
            message: '发送验证码成功',
            // 可用的值: 'positive', 'negative', 'warning', 'info'
            type: 'positive',
            position: 'top', // 'top', 'left', 'bottom-left'等
          });
        });
    }, */
    // 发送短信/邮箱，需要极验
    _sendMsg () {
      let isPhone = this.type == 'phone';
      let countryCode = this.countryCode;
      if (isPhone) {
        if (countryCode.charAt(0) !== '+') {
          countryCode = '+' + countryCode;
        }
      }
      let data = {
        phone: this.value,
        templateCode: this.templateCode,
        countryCode
      };
      switch (this.type) {
        case 'email':
          data.validateType = 1;
          break;
        case 'phone':
          data.validateType = 2;
          break;
        case 'register':
          data.validateType = 3;
          break;
        case 'forgot-pwd':
          data.validateType = 4;
          break;
        default:
          data.validateType = 1;
      }

      let geetest;
      if (this.geetest) {
        geetest = {
          ...this.captchaSuccess,
          sign: this.sign
        };
      }

      return commonApi
        .sendSms(data, geetest)
        .then(response => {
          this.successNotify(this.$t('success.verifyBtn'));
          return response;
        })
        .catch(error => {
          return error;
        });
    }
  },
  computed: {
    btnText() {
      if (this.started) {
        return this.onProgressText.replace(/{(\w+)}/, this.countTime);
      }
      let btnText = '';
      switch (this.type) {
        case 'email':
          btnText = this.$t('actions.sendEmailOtp');
          break;
        case 'phone':
          btnText = this.$t('actions.sendOtp');
          break;
        default:
          btnText = this.$t('actions.sendOtp');
      }

      if (this.isFirstStart) {
        return btnText;
      }
      if (this.stoped) {
        return btnText;
      }
    }
  },
  mounted() {
    let that = this;
    if (this.geetest) {
      this.initGeetest('a', 'bind', data => {
        this.loading = true;
        that
          ._sendMsg()
          .then(() => {
            this.loading = false;
            that.isFirstStart = false;
            that.started = true;
            that.stoped = false;
            that.disable = true;
            that.$emit('onstart', that.countTime);
            this.timer = setInterval(() => {
              if (that.countTime - 1 < 0) {
                clearInterval(that.timer);
                that.started = false;
                that.stoped = true;
                that.disable = false;
                that.countTime = parseInt(that.time);
                that.$emit('onstop', that.countTime);
                return;
              }
              that.countTime--;
              that.$emit('onprogress', that.countTime);
            }, 1000);
          })
          .catch(() => {
            this.loading = false;
          });
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.verify-btn {
  &.disabled {
    cursor: not-allowed;
  }  
}
</style>